import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "self-attachment-container",
  id: "full-siblings-component-container"
}
const _hoisted_2 = { id: "self-node" }
const _hoisted_3 = {
  key: 1,
  class: "self-attachment-container"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "self-connector" }, null, -1)

import { onMounted, onUpdated, ref } from "vue";
import Person from "@/bll/models/Person.mjs";
import MemberNode from "./MemberNode.vue";
import TreeUtils from "@/bll/tree_utils.mjs";
import BllUtils from "@/bll/utils.mjs";
import FamilyMember from "@/bll/models/FamilyMember.mjs";
import FullSiblingComponent from "./FullSiblingComponent.vue";

interface Props {
  member: Person;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelfComponent',
  props: {
    member: {}
  },
  setup(__props: any) {

const props = __props;

const container = ref();



let fullSiblings: FamilyMember[] | null = null;

onMounted(() => {
  updateFullSiblingPosition();
});

onUpdated(() => {
  updateFullSiblingPosition();
});

function getFullSiblings(): FamilyMember[] {
  return (
    fullSiblings ||
    BllUtils.filterFullSiblings(props.member, [
      ...props.member._brothers,
      ...props.member._sisters,
    ])
  );
}

function updateFullSiblingPosition() {
  setTimeout(() => {
    const fullSiblingContainer = container.value.querySelector(
      ":scope #full-siblings-component-container"
    );

    if (!fullSiblingContainer) {
      return;
    }

    const fullSiblingsBuffer = 150;
    const treeContainer = document.querySelector(".tree-container");

    fullSiblingContainer.style.left =
      treeContainer!.getBoundingClientRect().left -
      fullSiblingContainer.getBoundingClientRect().right -
      fullSiblingsBuffer +
      "px";
  }, 0);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "self-component-container",
    ref_key: "container",
    ref: container
  }, [
    (getFullSiblings().length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(FullSiblingComponent, {
            siblings: getFullSiblings()
          }, null, 8, ["siblings"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MemberNode, {
        member: _ctx.member,
        "display-top-bar": _unref(TreeUtils).getAncestors(_ctx.member).length > 0,
        "display-bottom-bar": _unref(TreeUtils).getDescendents(_ctx.member).length > 0
      }, null, 8, ["member", "display-top-bar", "display-bottom-bar"])
    ]),
    (_ctx.member._spouses.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.member._spouses, (self) => {
            return (_openBlock(), _createBlock(MemberNode, {
              key: self.name + '-' + _ctx.member.name,
              member: self,
              "display-top-bar": _unref(TreeUtils).getAncestors(self).length > 0,
              "display-bottom-bar": _unref(TreeUtils).getDescendents(self).length > 0
            }, null, 8, ["member", "display-top-bar", "display-bottom-bar"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})